import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
  InputRightElement,
} from '@chakra-ui/react';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { type MouseEvent } from 'react';
import { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form';

interface InputDateProps extends InputProps {
  name: string;
  register: UseFormRegister<FieldValues>;
  errors?: Partial<FieldErrorsImpl<{ [x: string]: string }>>;
  showClearButton?: boolean;
  onClear?: (event: MouseEvent<HTMLButtonElement>) => void;
  clearAriaLabel?: string;
}

function InputDate({
  name,
  errors,
  register,
  showClearButton = false,
  onClear,
  clearAriaLabel = 'Bersihkan tanggal',
  ...props
}: InputDateProps) {
  const errorMessage = errors ? errors[name]?.message : '';
  const rightElementWidth = showClearButton ? '4.5rem' : '2.5rem';

  return (
    <InputGroup>
      <InputLeftElement
        children={<Icon as={CalendarTodayOutlinedIcon} color="gray.75" />}
      />
      <Input
        variant="outline"
        placeholder="DD/MM/YYYY"
        pr={rightElementWidth}
        {...register(name)}
        {...props}
      />
      {errorMessage && <span>This field is required</span>}
      <InputRightElement width={rightElementWidth} pointerEvents="auto">
        <>
          {showClearButton ? (
            <IconButton
              aria-label={clearAriaLabel}
              icon={<Icon as={CloseIcon} boxSize={3.5} />}
              size="xs"
              variant="ghost"
              onClick={onClear}
              mr={1}
            />
          ) : null}
          <Icon as={ExpandMoreOutlinedIcon} color="gray.75" />
        </>
      </InputRightElement>
    </InputGroup>
  );
}

export default InputDate;
